module.exports = __webpack_public_path__ + "static/media/list.cc8e621c.svg";